




































import { Component } from 'vue-property-decorator';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import RegionDetails from '@/components/Settings/Regions/RegionDetails.vue';
import RegionPublicHolidays from '@/components/Settings/Regions/RegionPublicHolidays.vue';

@Component({ name: 'Region', components: { Alert, RegionDetails, RegionPublicHolidays }, metaInfo: { title: 'Regions' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await RegionsModule.getRegion(this.$route.params.id);
    }

    get region() {
        return RegionsModule.region;
    }

    get loading() {
        return RegionsModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
